import { render } from "./SpeakerDetail.vue?vue&type=template&id=e4023e36&scoped=true"
import script from "./SpeakerDetail.vue?vue&type=script&lang=js"
export * from "./SpeakerDetail.vue?vue&type=script&lang=js"

import "./SpeakerDetail.vue?vue&type=style&index=0&id=e4023e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4023e36"]])

export default __exports__